export const mb=p=>o=>p.map(c=>o=(o||{})[c])&&o // eslint-disable-line

export const swap = (array, a, b) =>
	array.map((item, index) => {
		if (index === a) return array[b]
		else if (index === b) return array[a]
		else return item
	})

export const pick = (obj, ...fields) =>
	fields.reduce(
		(acc, field) => ({
			...acc,
			[field]: obj[field],
		}),
		{}
	)
